module.exports = __webpack_public_path__ + "static/media/Nathalie.30441f1d.jpg";